import {createSlice, PayloadAction} from '@reduxjs/toolkit'

export const emptySearch: searchRentalsState = {
	filter: undefined,
	region: undefined,
	houseType: undefined,
	houseCapacity: 4,
	houseName: '',
	period: undefined,
	features: {},
	types: {},
	priceRange: undefined,
	specials: {},
	isPromo: undefined,
	isNew: undefined,
	special: undefined,
	page: 1,
	slug: undefined,
	sort: undefined,
}

const initialState: searchRentalsState = {
	...emptySearch,
	isSearchPanelActive: false,
}

const searchRentalsSlice = createSlice({
	name: 'searchRentals',
	initialState,
	reducers: {
		setSearchPanel(state, action: PayloadAction<boolean>) {
			state.isSearchPanelActive = action.payload
		},
		setFeaturesFilter(
			state,
			action: PayloadAction<searchRentalsState['features']>
		) {
			state.houseName = ''
			state.page = 1
			state.features = {...state.features, ...action.payload}
		},
		clearFeaturesFilter(state) {
			state.features = {}
		},
		setTypesFilter(state, action: PayloadAction<searchRentalsState['types']>) {
			state.houseName = ''
			state.page = 1
			state.types = {...state.types, ...action.payload}
		},
		setSpecialsFilter(
			state,
			action: PayloadAction<searchRentalsState['specials']>
		) {
			state.houseName = ''
			state.page = 1
			state.specials = {...state.specials, ...action.payload}
		},
		clearSpecialsFilter(state) {
			state.houseName = ''
			state.page = 1
			state.specials = {}
		},
		setPriceRangesFilter(
			state,
			action: PayloadAction<searchRentalsState['priceRange']>
		) {
			state.houseName = ''
			state.page = 1
			state.priceRange = action.payload
		},
		setRentalRegion(state, action: PayloadAction<{label: string}>) {
			state.houseName = ''
			state.page = 1
			state.region = action.payload.label
		},
		setPromo(state, action: PayloadAction<boolean>) {
			state.houseName = ''
			state.page = 1
			state.isPromo = !!action.payload || undefined
		},
		setHouseName(state, action: PayloadAction<string>) {
			Object.assign(state, {...emptySearch, houseName: action.payload, page: 1})
		},
		setNew(state, action: PayloadAction<boolean>) {
			state.houseName = ''
			state.page = 1
			state.isNew = !!action.payload || undefined
		},
		setRentalType(state, action: PayloadAction<{label: string}>) {
			state.houseName = ''
			state.page = 1
			state.houseType = action.payload.label
		},
		setRentalSize(state, action: PayloadAction<number>) {
			state.houseName = ''
			state.page = 1
			state.houseCapacity = action.payload
		},
		setRentalPeriod(state, action: PayloadAction<{period: string}>) {
			state.houseName = ''
			state.page = 1
			state.period = action.payload.period
		},
		setSort(state, action: PayloadAction<{sort: searchRentalsState['sort']}>) {
			state.page = 1
			state.sort = action.payload.sort
		},
		clearSearch(state) {
			Object.assign(state, {...emptySearch, page: initialState.page})
		},
		setRegionDefault(state) {
			state.region = undefined
		},
		setTypeDefault(state) {
			state.houseType = undefined
		},
		setSizeDefault(state) {
			state.houseCapacity = undefined
		},
		setSearch(state, action: PayloadAction<Partial<searchRentalsState>>) {
			Object.assign(state, {
				...state,
				...action.payload,
				features: {...initialState.features, ...action.payload.features},
			})
		},
		setPage(state, action: PayloadAction<number>) {
			state.page = action.payload
		},
		setPageDefault(state) {
			state.page = initialState.page
		},
	},
})

export const {
	setSearchPanel,
	setFeaturesFilter,
	clearFeaturesFilter,
	setTypesFilter,
	setSpecialsFilter,
	clearSpecialsFilter,
	setPriceRangesFilter,
	setRentalRegion,
	setSort,
	setPromo,
	setHouseName,
	setNew,
	setRentalType,
	setRentalSize,
	setRentalPeriod,
	clearSearch,
	setRegionDefault,
	setTypeDefault,
	setSizeDefault,
	setSearch,
	setPage,
	setPageDefault,
} = searchRentalsSlice.actions

export default searchRentalsSlice.reducer
